module.exports = __webpack_public_path__ + "static/media/in-ski-short-promo.63c61e88.mp4";